export const triggerProgress = (setTimeleft) => {
	const interval = setInterval(() => {
		if (setTimeleft) {
			setTimeleft((oldValue) => {
				const newValue = oldValue + 10;

				if (newValue === 100) {
					clearInterval(interval);
				}

				return newValue;
			});
		}
	}, 1000);
};
